import { NewJourneyNotificationModalTranslations } from "./new-journey-notification-modal-pt-br";

export const NEW_JOURNEY_NOTIFICATION_MODAL_EN_US: NewJourneyNotificationModalTranslations = {
	title: "Your withdrawal journey just got simpler",
	content:
		'Zig unified the withdrawal and anticipation journeys into a single flow, bringing more agility to those who need to access their operation funds. Click "See Wallet" and try the new journey.',
	primaryActionLabel: "Close",
};
